// extracted by mini-css-extract-plugin
module.exports = {"hidden":"messageModal_hidden__19zLz","textEmphasis":"messageModal_textEmphasis__ZZZS5","messageArea":"messageModal_messageArea__DFlYk"};